import { CategoryBannerProps } from "components/CategoryBanner/CategoryBanner";
import { CategoryLensTypes, GlassesCategory } from "constants/dataTypes";
import { filterLensTypes } from "functions/filterLensTypes";
import { wcApiDataService } from "functions/wcApi";
import { GetStaticPaths, GetStaticProps } from "next";
import { getPageHeaderData, getSeoBlockContent, getSeoMetaTags, getCategoryBannerImages } from "utils/common.utils";
import { generateImageW } from "utils/image.utils";
import ShopCategory from "../..";


export default ShopCategory;

export const getStaticPaths: GetStaticPaths = async () => {

  return {
    paths: [],
    fallback: 'blocking',
  }
 
}

export const getStaticProps: GetStaticProps = async ({ params, locale }) => {

  let { category, colour } = params as { category: string; colour: string };

  if (category === 'sunglasses') {
    category = 'non-prescription-sunglasses';
  }

  var categoryData: GlassesCategory = await wcApiDataService('cat/' + category, '', locale);

  var productDetailPageData: any = await wcApiDataService('glasses/' + category, '', locale);

  const glassesProductData = productDetailPageData?.components;
  const categoryLensTypes: CategoryLensTypes[] = filterLensTypes(glassesProductData);

  if (!categoryData) {
    return {
      notFound: true
    };
  }

  const seoBlock = await getSeoBlockContent('/shop/' + category + '/colour/' + colour, locale);

  const categoryBannerImages = await getCategoryBannerImages(params?.category as string, locale);
  const seoMetaTags = await getSeoMetaTags('/shop/' + category + '/colour/' + colour, locale);

  const categoryBannerProps: CategoryBannerProps = {
    title: categoryData.name,
    description: categoryData.description,
    imageSrc: generateImageW(categoryData.slug, 'categories', 'slug', 'banner', 'jpg')
  }

  const notionPageHeaders = await getPageHeaderData(category + '/colour/' + colour as string, locale, categoryBannerProps);

  if (notionPageHeaders == categoryBannerProps) {
    const mainPageHeader = await getPageHeaderData(category as string, locale, categoryBannerProps);
    notionPageHeaders.imageSrc = mainPageHeader?.imageSrc ?? '';
    notionPageHeaders.imageAlt = mainPageHeader?.imageAlt ?? '';
    notionPageHeaders.videoSrc = mainPageHeader?.videoSrc ?? '';
  }

  return {
    props: {
      categoryData: categoryData,
      seoBlock,
      seoMetaTags,
      categoryLensTypes,
      categoryBannerProps: notionPageHeaders,
      categoryBannerImages
    }
  }
}